import { ApolloClientOptions, InMemoryCache, ApolloLink } from '@apollo/client/core';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';

import { environment } from '../environments/environment';

const ADMIN_URI = environment.adminApiUrl;
const CLIENT_URI = environment.clientApiUrl;

export function createApollo(): void {
  const apollo = inject(Apollo);
  const httpLink = inject(HttpLink);

  const adminLink = httpLink.create({ uri: ADMIN_URI });
  const clientLink = httpLink.create({ uri: CLIENT_URI });

  const link = ApolloLink.split(
    (operation) => operation.getContext()['clientName'] === 'client',
    clientLink,
    adminLink
  );

  apollo.create({
    link,
    cache: new InMemoryCache(),
  });
}

export const graphqlProvider: ApplicationConfig['providers'] = [
  provideHttpClient(withInterceptors([authInterceptor])),
  Apollo,
  provideAppInitializer(() => {
    createApollo();
  }),
];
